module.exports = __webpack_public_path__ + "static/media/sign-out.ab6eee12.svg";